import React from 'react';
import { useNavigate } from "react-router-dom";
import { Row, Modal } from 'react-bootstrap';
import { Button } from '@mui/material';
import GetAmericoHealthClass from '../../MCT/Helpers/GetAmericoHealthClass';
import { setSessionStorageItem, SESSION_STORAGE_AMERICO_OBJECT_KEY } from '../../../../sessionStorage';

export default function AmericoQuoteModel(props) {
    const navigate = useNavigate();
    const handleAmericoQuoteOnNext = () => {
        var form = { ...props.fullFormState };
        var healthClassValue = GetAmericoHealthClass(props.healthClass);
        var tobacco = props.basicInfo.tobacco === 'true' ? 'Over 36 months' : 'Never';
        const AMERICO_SESSION_STORAGE_KEY = "AMERICO_QUOTE";
        const customData = {
            coverageAmount: props.coverageAmount,
            healthClass: healthClassValue,
            premium: form.pages.quoter.premium,
            term: props.termLength,
            cashValue: form.pages.quoter.cashValue,
            logoUrl: form.pages.quoter.logoUrl,
            backUrl:'/term-insurance/quote-results',
            tobacco : tobacco,
            isFromAmerico : true
        }
        setSessionStorageItem(SESSION_STORAGE_AMERICO_OBJECT_KEY, customData)
        sessionStorage.removeItem(AMERICO_SESSION_STORAGE_KEY);
        navigate('/loan-protection/getting-started');
    }
    return (
        <Modal show={props.americoModalShow} style={{zIndex: 1400}} onHide={props.handleAmericoModalClose} backdrop="static" centered>
            <Modal.Body className="model-body d-flex align-items-center justify-content-center p-3 flex-column ">
                <p className='model-header'>LoanMatch Protector is a decreasing term product</p>
                <p className='model-content'>Your insurance coverage will decrease over time to match the balance of a loan or other decreasing financial obligation.</p>
                <Row>
                    <div className='pt-2'>
                        <Button variant='contained' size="medium" color="primary" onClick={handleAmericoQuoteOnNext}>Continue</Button>
                    </div>
                </Row>
                <Row className='mt-2'>
                    <div>
                        <Button size="medium" color="primary" onClick={props.handleAmericoModalClose}>Back</Button>
                    </div>
                </Row>
            </Modal.Body>
        </Modal>
    )
}
